import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { BRAND_COPYRIGHT, SERVICE_BRAND_NAME, brandPageAttributes } from '../../config/brandConfig';
import './PhpPayLoginShell.css';

function PhpPayLoginShell({
  logoSrc,
  logoStyle,
  portalLabel,
  title,
  description,
  heroTitle = '결제의 흐름을\n더 간편하게',
  heroDescription = '매장과 현장을 연결하는 간편한 결제 운영 서비스',
  variant = 'desktop',
  children,
}) {
  const heroTitleLines = heroTitle.split('\n');

  return (
    <div
      {...brandPageAttributes}
      className={`phpay-login-shell phpay-login-shell--${variant}`}
    >
      <section className="phpay-login-hero" aria-label={`${SERVICE_BRAND_NAME} 소개`}>
        <div className="phpay-login-hero__inner">
          <div className="phpay-login-logo-box">
            <img
              src={logoSrc}
              alt={SERVICE_BRAND_NAME}
              className="phpay-login-logo"
              style={logoStyle}
            />
          </div>

          <div className="phpay-login-hero__copy">
            <span className="phpay-login-hero__eyebrow">PAYMENT, SIMPLIFIED</span>
            <h1>
              {heroTitleLines.map((line, index) => (
                <React.Fragment key={line}>
                  {index > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </h1>
            <p>{heroDescription}</p>
          </div>

          <div className="phpay-login-hero__status">
            <ShieldCheck size={17} aria-hidden="true" />
            안전하고 간편한 결제 운영
          </div>
        </div>
      </section>

      <main className="phpay-login-form-pane">
        <div className="phpay-login-form-panel">
          <span className="phpay-login-portal-label">{portalLabel}</span>
          <h2>{title}</h2>
          <p className="phpay-login-form-description">{description}</p>
          {children}
          <p className="phpay-login-copyright">{BRAND_COPYRIGHT}</p>
        </div>
      </main>
    </div>
  );
}

export default PhpPayLoginShell;
